import React from 'react';
import  IneternationalIsc2024  from 'views/IneternationalIsc2024';
const VissionAndMissionPage = () => {
  return <IneternationalIsc2024/>;
};

export default VissionAndMissionPage;
